document.addEventListener('DOMContentLoaded',function(){
  const btn=document.querySelector('[data-menu-toggle],[data-td-menu]');
  const nav=document.querySelector('[data-menu],[data-td-nav]');
  if(btn&&nav){
    const closeMenu=()=>{btn.setAttribute('aria-expanded','false');nav.classList.remove('is-open');};
    btn.addEventListener('click',()=>{const open=btn.getAttribute('aria-expanded')==='true';btn.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open);});
    nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',closeMenu));
    document.addEventListener('keydown',e=>{if(e.key==='Escape') closeMenu();});
  }
  document.querySelectorAll('a[href="/collections/tarantulas"],a[href$="/collections/tarantulas"]').forEach(function(link){
    link.addEventListener('click',function(e){
      if(link.dataset.tdNavLocked==='true'){
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      link.dataset.tdNavLocked='true';
      link.setAttribute('aria-busy','true');
    },true);
  });

  /* V64 navigation performance: warm likely internal pages before the customer clicks. */
  const prefetched=new Set();
  const skipPrefetch=/^(#|mailto:|tel:|javascript:)/i;
  function prefetchLink(link){
    if(!link||link.dataset.tdPrefetched==='true'||link.target==='_blank'||link.hasAttribute('download')) return;
    const href=link.href;
    if(!href||skipPrefetch.test(href)) return;
    let url;
    try{url=new URL(href,location.href);}catch(e){return;}
    if(url.origin!==location.origin) return;
    if(url.pathname==='/cart'||url.pathname.startsWith('/cart/')||url.pathname==='/checkout'||url.pathname.startsWith('/checkout/')||url.pathname==='/account'||url.pathname.startsWith('/account/')||url.pathname==='/search') return;
    if(prefetched.has(url.href)) return;
    prefetched.add(url.href);
    link.dataset.tdPrefetched='true';
    const preload=document.createElement('link');
    preload.rel='prefetch';
    preload.href=url.href;
    document.head.appendChild(preload);
  }
  document.addEventListener('pointerover',function(e){
    const link=e.target.closest&&e.target.closest('a[href]');
    if(link) prefetchLink(link);
  },{passive:true});
  document.addEventListener('touchstart',function(e){
    const link=e.target.closest&&e.target.closest('a[href]');
    if(link) prefetchLink(link);
  },{passive:true});
});
